import React from 'react';
import { IncidentAnalysis } from '../../types/incident';

interface CauseAndSolutionProps {
    analysis: IncidentAnalysis;
}

const CauseAndSolution: React.FC<CauseAndSolutionProps> = ({ analysis }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {analysis.potential_cause && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h4 className="font-medium text-gray-900 mb-4">Root Cause Analysis</h4>
                    <div className="p-3 bg-red-50 rounded-md">
                        <h5 className="font-medium text-red-900 mb-1">Potential Cause</h5>
                        <p className="text-red-800">{analysis.potential_cause}</p>
                    </div>
                </div>
            )}

            {analysis.potential_solution && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h4 className="font-medium text-gray-900 mb-4">Recommended Solution</h4>
                    <div className="p-3 bg-green-50 rounded-md">
                        <h5 className="font-medium text-green-900 mb-1">Potential Solution</h5>
                        <p className="text-green-800">{analysis.potential_solution}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CauseAndSolution;
